import { SNItem } from './snitem';

export class CNItem extends SNItem {

    public dateparts;
    public dateweek;
    public dateindex;

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem';
    }

    public get validated(): boolean {
        return this.getProperty('Validated') === 'Yes' ? true : false;
    }

    public get seen(): boolean {
        return this.getProperty('Seen') === 'Yes' ? true : false;
    }

    public validate(flag: boolean) {
        this.setProperty('Validated', flag ? 'Yes' : 'No');
    }

    public clone(): any {
        return new CNItem();
    }

    public fromJson(json, emitLoaded = true) {
        super.fromJson(json, emitLoaded);
        if (typeof json.dateparts !== 'undefined') {
            this.dateparts = json.dateparts;
        }
        if (typeof json.dateweek !== 'undefined') {
            this.dateweek = json.dateweek;
        }
        if (typeof json.dateindex !== 'undefined') {
            this.dateindex = json.dateindex;
        }
    }
}
